import { supabase } from "../../../supabaseClient";

export async function fetchSquadsForTournament(tournamentId) {
  const { data, error } = await supabase
    .from("squads")
    .select("id, squadDate")
    .eq("tournamentID", tournamentId)
    .eq("isDeleted", false);

  if (error) throw error;
  return data || [];
}
